import React, { Component } from 'react';
import globalizacao from '../escolha/globalizacao';
import Team from '../components/team';

class HomeTeam extends Component {

    render() {
        return (
            <section className="secao team fundo-white">
                <div className="limite conteudo">
                    <h2>{globalizacao.msg("nossaEquipe")}</h2>
                   
                   
                    <Team />
                </div>
            </section>

        );
    }
}

export default HomeTeam;



// WEBPACK FOOTER //
// ./src/js/pages/home-team.js